import {createContext} from 'react'

const BSSPreventivoContext = createContext({})
export const BSSPreventivoProvider = BSSPreventivoContext.Provider
export default BSSPreventivoContext
